import { EmbedYoutubeBlockService } from '@blocksuite/blocks';

export class PiqueEmbedYoutubeBlockService extends EmbedYoutubeBlockService {
  override mounted(): void {
    super.mounted();
  }
}
